var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtnToggle',_vm._g({class:_vm.classList,attrs:{"mandatory":""},on:{"change":_vm.emitInput}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }